import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "16",
  viewBox: "0 0 17 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M13.5 10.25a.75.75 0 0 1 .75.75v1a1.75 1.75 0 0 1-1.75 1.75h-8A1.75 1.75 0 0 1 2.75 12v-1a.75.75 0 0 1 1.5 0v1c0 .138.112.25.25.25h8a.25.25 0 0 0 .25-.25v-1a.75.75 0 0 1 .75-.75M7.263 2.677a1.75 1.75 0 0 1 2.474 0L13.03 5.97a.75.75 0 0 1-1.06 1.06L9.25 4.31V10a.75.75 0 0 1-1.5 0V4.31L5.03 7.03a.75.75 0 0 1-1.06-1.06z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }